// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2H8zm","dragIcon":"Choice_dragIcon__3-v9L","left":"Choice_left__AGWx6","input":"Choice_input__3zVte"};